import { createStore as _createStore, applyMiddleware, combineReducers } from 'redux'
import thunk from 'redux-thunk'
import promiseMiddleware from 'redux-promise'
import createLogger from 'redux-logger'
import config from 'util/config.js'

import { readState, storeState } from './persistance'
import app from './modules/app'
import findputter from './modules/findputter'
import customize from './modules/customize'
import { EventAnalyticsMiddleware } from '../util/analytics';

export default function createStore() { 

  const reducer = combineReducers({
      app,
      findputter,
      customize,
    });

  let middleware = [promiseMiddleware, thunk, EventAnalyticsMiddleware];

  if (!config.production){
    middleware = middleware.concat(createLogger()); //must be last in middleware chain
  }


  const persistedState = readState();
  const store = _createStore(
    reducer,
    persistedState,
    applyMiddleware(...middleware)
  )

  store.subscribe(() => storeState(store.getState()))

  return store;
}
